import { wsService } from "./wsService";
import axios from "axios";

const api_url = process.env.VUE_APP_API_URL;
const section = "products/qualities";

const PRIMERA = 1;
const SEGUNDA = 2;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

export const productQualityService = {
  section,
  filter,
  PRIMERA,
  SEGUNDA,

};
